import ChevronRight from '@ixigo/icons/ChevronRight';
import ButtonBase from '@ixigo/iui/ButtonBase';
import ListItem from '@ixigo/iui/ListItem';
import ListItemIcon from '@ixigo/iui/ListItemIcon';
import ListItemText from '@ixigo/iui/ListItemText';
import cn from '@repo/shared/utils/cn';

interface CardProps {
	title: string;
	subtitle: string;
	icon: React.ReactNode;
	onClick: () => void;
	className?: string;
}

export function ListCard(cardProps: CardProps) {
	const { title, subtitle, icon, onClick, className } = cardProps;

	return (
		<ButtonBase onClick={onClick} className={cn('w-full', className)}>
			<ListItem className="hover:bg-transparent py-10" disablePadding>
				<ListItemIcon
					type="icon"
					data-testid="banner-icon"
					className="text-secondary"
				>
					{icon}
				</ListItemIcon>
				<ListItemText
					primary={title}
					secondary={subtitle}
					className="lg:font-normal text-left"
				/>
				<ListItemIcon type="icon" className="justify-end items-center">
					<ChevronRight data-testid="chevron-right" />
				</ListItemIcon>
			</ListItem>
		</ButtonBase>
	);
}
